import { useEffect, useState } from "react";
import { twMerge } from "tailwind-merge";
import { ArrowLeft, ArrowRight } from "lucide-react";
import { Button } from "@themes/pollinator/ui/Button";
import { Loader } from "@themes/pollinator/ui/Loader";
import { ProgramPhase } from "@core/features/program";

export type Props = {
  phases: ProgramPhase[];
  selectedPhase: ProgramPhase | undefined;
  setSelectedPhase: (phase: ProgramPhase) => void;
};

export function ProgramPhaseListNavigation({
  phases,
  selectedPhase,
  setSelectedPhase,
}: Props) {
  const [selectedPhaseIndex, setSelectedPhaseIndex] = useState<number>(0);

  useEffect(() => {
    setSelectedPhaseIndex(
      phases.findIndex((phase) => phase.id === selectedPhase?.id)
    );
  }, [selectedPhase]);

  const goToPrevPhase = () => {
    if (selectedPhaseIndex > 0) {
      setSelectedPhase(phases[selectedPhaseIndex - 1]);
    }
  };

  const goToNextPhase = () => {
    if (selectedPhaseIndex < phases.length - 1) {
      setSelectedPhase(phases[selectedPhaseIndex + 1]);
    }
  };

  if (!selectedPhase) return <Loader />;

  return (
    <div
      className={twMerge(
        "w-full md:hidden py-4 flex gap-4 justify-between",
        selectedPhaseIndex === 0 && "justify-end",
        selectedPhaseIndex === phases.length - 1 && "justify-start"
      )}
    >
      {selectedPhaseIndex > 0 && (
        <Button
          variant="secondary"
          onClick={goToPrevPhase}
          iconComponent={ArrowLeft}
          className="max-w-1/2"
          data-testid="program-phase-prev"
        >
          {phases[selectedPhaseIndex - 1].name}
        </Button>
      )}
      {selectedPhaseIndex < phases.length - 1 && (
        <Button
          variant="secondary"
          onClick={goToNextPhase}
          iconComponent={ArrowRight}
          iconPosition="right"
          className="max-w-1/2"
          data-testid="program-phase-next"
        >
          {phases[selectedPhaseIndex + 1].name}
        </Button>
      )}
    </div>
  );
}

export default ProgramPhaseListNavigation;

